import { SiteType } from "../types/api";

export const imagePath = (
  path: string,
  query: string = "width=300&quality=75&resize=contain"
) => {
  if (!path) return null;

  if (path.startsWith("http")) return path;

  return `${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/uploads/${path}`;
};

export const createDocsUrl = (site?: SiteType): string => {
  if (process.env.NODE_ENV === "development") {
    return `${site?.subdomain ?? ""}${
      process.env.REACT_APP_COOKIE_DOMAIN
    }:8888`;
  }

  if (site?.custom_domain) return site?.custom_domain;

  return `${site?.subdomain ?? ""}${process.env.REACT_APP_COOKIE_DOMAIN}`;
};
